import React from "react";


export default function HeaderMobile({ ascendente, descendente, ordenBronce, ordenOro, ordenPlata, ordenTotal, FilterGold, FilterSilver, FilterBronce, FilterTotal }) {

    return (
        <>
            <div className="medallero-header-medallas hiddenDiv">
                <div className="medallero-header-medallas-tipo" onClick={() => FilterGold()}    >
                    Oro
                    <div className="arrows">
                        <div className={ordenOro === descendente ? "arrow-top active" : "arrow-top"}  ></div>
                        <div className={ordenOro === ascendente ? "arrow-bottom active" : "arrow-bottom"} ></div>
                    </div>
                </div>

                <div className="medallero-header-medallas-tipo" onClick={() => FilterSilver()}  >
                    Plata
                    <div className="arrows">
                        <div className={ordenPlata === descendente ? "arrow-top active" : "arrow-top"} ></div>
                        <div className={ordenPlata === ascendente ? "arrow-bottom active" : "arrow-bottom"}  ></div>
                    </div>
                </div>

                <div className="medallero-header-medallas-tipo" onClick={() => FilterBronce()}>
                    Bronce
                    <div className="arrows">
                        <div className={ordenBronce === descendente ? "arrow-top active" : "arrow-top"} ></div>
                        <div className={ordenBronce === ascendente ? "arrow-bottom active" : "arrow-bottom"} ></div>
                    </div>
                </div>
            </div>

            <div className="medallero-header-total hiddenDiv" onClick={() => FilterTotal()}  >
                Total
                <div className="arrows">
                    <div className={ordenTotal === descendente ? "arrow-top active" : "arrow-top"} ></div>
                    <div className={ordenTotal === ascendente ? "arrow-bottom active" : "arrow-bottom"}   ></div>
                </div>
            </div>
        </>
    )
}